import React, { useEffect, useState } from 'react';
import { Flexbox, FlexboxColumn } from '../../../components/action/Flexbox';
import OTPInput from '../../../components/action/OTPInput';
import ButtonApi from '../../../components/ButtonApi';
import ThemedText from '../../../components/theme/ThemedText';
import { useBackendApi } from '../../../helpers/backendHelper';
import './Puzzle.scss';

const Puzzle = ({ handleOtp, handlePuzzle }) => {
  const [otp, setOtp] = useState();
  const [puzzleStats, setPuzzleStats] = useState();
  const backendHelper = useBackendApi();

  async function handlePuzzleStats() {
    try {
      const response = await backendHelper.reviews.puzzleCodeStats();
      setPuzzleStats(response.data);
    } catch (error) {
      setPuzzleStats({});
    }
  }

  async function handleCode() {
    if (otp.length < 6) return alert.error('Enter Code');
    try {
      const body = {
        code: otp,
      };
      await backendHelper.reviews.postPuzzleCode(body);
      handleOtp(true);
    } catch (error) {
      handleOtp(false);
      console.log('error is Postmegacode', error);
      alert.error('Invalid Code');
    }
  }

  useEffect(() => {
    handlePuzzleStats();
  }, []);

  if (puzzleStats === undefined)
    return (
      <FlexboxColumn className='invite_wrapper' gap='3rem' justifyContent='flex-start'>
        <span className='invite_wrapper_loader'></span>
      </FlexboxColumn>
    );

  return (
    <div className='game'>
      <div className='game_prompt'>
        <ThemedText.H2> give f**ks, only when you’re smart</ThemedText.H2>
        <ThemedText.P color='color-xlight'>
          {' '}
          Can you crack this puzzle and uncover the 6-part alphanumeric <br /> invite code? No hints, no rules—just use your wits.
          <br />
          {puzzleStats?.count || 0} people have solved and used the invite code of this puzzle. Max limit of code is 100 uses.
        </ThemedText.P>
      </div>
      <div className='game_wrapper'>
        <div className='game_morse'>
          <div className='game_short'></div>
          <div className='game_tall'></div>
          <div className='game_blank'></div>

          <div className='game_tall'></div>
          <div className='game_tall'></div>
          <div className='game_blank'></div>

          <div className='game_short'></div>
          <div className='game_blank'></div>

          <div className='game_short'></div>
          <div className='game_tall'></div>
          <div className='game_short'></div>
          <div className='game_blank'></div>

          <div className='game_short'></div>
          <div className='game_short'></div>
          <div className='game_blank'></div>

          <div className='game_tall'></div>
          <div className='game_short'></div>
          <div className='game_tall'></div>
          <div className='game_short'></div>
          <div className='game_blank'></div>

          <div className='game_short'></div>
          <div className='game_tall'></div>
          <div className='game_blank'></div>
        </div>

        <div className='game_cipher'>0x6c6761636d6c634b6771726370437266796c506d6c796a626d56</div>

        <div className='game_shapes'>
          <div className='game_rectangle1'></div>
          <span className='game_separator'>+</span>
          <div className='game_rectangle2'></div>
          <span className='game_separator'>-</span>
          <div className='game_rectangle3'></div>
          <span className='game_separator'> = X * 10</span>
        </div>
      </div>

      {/* {puzzleStats !== undefined ? (
        puzzleStats?.count > 0 ? (
          <ThemedText.H5>(This puzzle is already solved by {puzzleStats?.firstUsage?.userAddress})</ThemedText.H5>
        ) : (
          <ThemedText.H5></ThemedText.H5>
        )
      ) : (
        <ThemedText.H5></ThemedText.H5>
      )} */}

      <FlexboxColumn>
        <ThemedText.P color='color-xlight'>What’s your guess child?</ThemedText.P>
        <Flexbox gap='1.5rem'>
          <OTPInput length={6} onChange={setOtp} />
          <ButtonApi className='invite_wrapper_submit_button' onClick={handleCode}>
            <ThemedText.H5>Submit</ThemedText.H5>
          </ButtonApi>
        </Flexbox>
      </FlexboxColumn>

      <a onClick={handlePuzzle}>Go back </a>
    </div>
  );
};

export default Puzzle;
